import _ from "lodash";
import { call, put, select, takeEvery } from 'redux-saga/effects';
import Cookies from "universal-cookie";
import { accountGetPortfolioAction } from "../modules/Account/accountActions.js";
import { setWelcomeApplyBonusAction } from "../modules/Bonus/bonusesActions";
import { bonusesSetActiveListSuccess, bonusesSetAvailableList } from "../modules/Bonus/bonusesActions.js";
import { MODALS_LOG_ACTION_TYPES } from "../modules/Modals/Modals";
import { setPartnerParams } from "../modules/Partner/partnerActions";
import {
    appInitAction,
    appInitFailure,
    appInitSuccess,
    appLog,
    completeOnboardingFailure,
    completeOnboardingSuccess,
    loadAccountTradeInfoFailure,
    loadAccountTradeInfoSuccess,
    updateAbTestIsUsedFailure,
    updateAbTestIsUsedSuccess,
    userPromocodeApplyAction,
    userPromocodeApplyFailure,
    userPromocodeApplySuccess,
    userPromocodeRemoveFailure,
    userPromocodeRemoveSuccess,
    userUpdateFailure,
    userUpdatePasswordFailure,
    userUpdateSuccess,
} from './appActions';
import {
    APP_INIT_START,
    APP_LOG,
    CLOSE_MODAL,
    COMPLETE_ONBOARDING_START,
    LOAD_ACCOUNT_TRADE_INFO_START,
    LOG_ACTION,
    LOG_APPSFLYER_ACTION,
    LOG_EVENT_TYPES,
    OPEN_MODAL,
    SET_RECENT_DONE,
    SET_USER_SELECTED_ACCOUNT_CODE,
    UPDATE_AB_TEST_IS_USED_START,
    USER_PROMOCODE_APPLY_START,
    USER_PROMOCODE_REMOVE_START,
    USER_UPDATE_PASSWORD_START,
    USER_UPDATE_START
} from './appConstants';
import { appHistoryPushWithSearchParams } from "./appHistory";
import {
    getPasswordMaxLengthSelector,
    getPasswordMinLengthSelector,
    makeSelectOpenedModalPrevious
} from './appSelectors';
import { checkIsPasswordValidWithParams } from "./appUtils";
import { failurePut } from './failurePut';
import { getRequest, postRequest, putRequest } from './request';

const browserCookies = new Cookies();

export function* appInitStartSaga() {
    try {
        const data = yield call(getRequest, '/init');

        yield put(appInitSuccess(data));
        yield put(bonusesSetActiveListSuccess(data.bonusesActive));
        yield put(bonusesSetAvailableList(data.bonusesAvailable))

        browserCookies.set('fp', data.fingerprint, { path: '/', maxAge: 60 * 60 * 24 * 365 });

        const params = new URLSearchParams(document.location.search);
        const coupon = params.get('coupon') || browserCookies.get('coupon');
        if (coupon && data.features.promocodes && !data.bonusesActive.find(item => item.name === 'forever')) {
            yield put(userPromocodeApplyAction({ promocode: coupon }));
            if (browserCookies.get('coupon')) {
                browserCookies.remove('coupon', { path: '/' });
            }
        }
        yield put(setPartnerParams(data.partner || {}));
    } catch (e) {
        yield call(failurePut, e, appInitFailure);
    }
}

export function* appLogSaga({ payload }) {
    try {
        yield call(postRequest, '/log', payload);
    } catch (e) {
    }
}

export function* locationChangeSaga({ payload }) {
    yield put(appLog({
        type: LOG_EVENT_TYPES.page,
        payload: {
            pathname: payload.location.pathname,
            search: payload.location.search,
        }
    }));
}

export function* logActionSaga({ payload }) {
    yield put(appLog({
        type: LOG_EVENT_TYPES.action,
        payload: payload,
    }));
}

export function* logAppsflyerSaga({ payload }) {
    if (!browserCookies.get('af_id')) {
        return
    }
    try {
        yield call(postRequest, '/log/appsflyer', payload);
    } catch (e) {
    }
}

export function* userUpdateSaga({ payload }) {
    try {
        const data = yield call(putRequest, '/user', { payload });

        yield put(userUpdateSuccess(data));
    } catch (e) {
        yield call(failurePut, e, userUpdateFailure);
    }
}

export function* checkPasswordComplexitySaga(password) {
    const passwordMaxLength = yield select(getPasswordMaxLengthSelector);
    const passwordMinLength = yield select(getPasswordMinLengthSelector);
    if (password.length < passwordMinLength) {
        return 'error.password_min_length';
    } else if (password.length > passwordMaxLength) {
        return 'error.password_max_length';
    } else if (!checkIsPasswordValidWithParams(password)) {
        return 'error.password_simple';
    }
    return '';
}

export function* userUpdatePasswordSaga({ payload }) {
    try {
        const passwordComplexityError = yield call(checkPasswordComplexitySaga, payload.passwordNew);
        if (passwordComplexityError) {
            yield put(userUpdatePasswordFailure(passwordComplexityError));
            return;
        }
        if (payload.passwordNew !== payload.passwordNew2) {
            yield put(userUpdatePasswordFailure('promo.fx.new_password.text2'));
            return;
        }
        yield call(putRequest, '/user/password/change', {
            password: payload.password,
            passwordNew: payload.passwordNew,
        });
        payload.callback && payload.callback();
    } catch (e) {
        yield call(failurePut, e, userUpdatePasswordFailure);
    }
}

export function* openModalSaga({ payload }) {
    try {
        const currentPayload = _.isObject(payload) ? payload: { name: payload };
        appHistoryPushWithSearchParams({
            m: currentPayload.name,
            tab: currentPayload.tab,
        });
        yield put(appLog({
            type: LOG_EVENT_TYPES.modal,
            payload: {
                action: MODALS_LOG_ACTION_TYPES.OPEN,
                ...currentPayload,
            }
        }));
    } catch (e) {

    }
}

export function* closeModalSaga() {
    try {
        const openedModal = yield select(makeSelectOpenedModalPrevious());
        appHistoryPushWithSearchParams({
            m: null,
            tab: null,
        });
        yield put(appLog({
            type: LOG_EVENT_TYPES.modal,
            payload: {
                action: 'close',
                ...openedModal,
            }
        }));
    } catch (e) {

    }
}

export function* completeOnboardingSaga() {
    try {
        yield call(postRequest, '/user/onboarding/complete');
        yield put(completeOnboardingSuccess());
    } catch (e) {
        yield put(completeOnboardingFailure());
    }
}

export function* userPromocodeApplySaga({ payload }) {
    try {
        yield call(postRequest, '/user/promocode/apply', payload);
        yield put(userPromocodeApplySuccess());
        yield put(appInitAction());
        yield put(accountGetPortfolioAction());
        yield put(setWelcomeApplyBonusAction(true));
    } catch (e) {
        yield call(failurePut, e, userPromocodeApplyFailure);
    }
}

export function* userPromocodeRemoveSaga({ payload }) {
    try {
        yield call(postRequest, '/user/promocode/remove', payload);
        yield put(userPromocodeRemoveSuccess());
        yield put(appInitAction());
        yield put(accountGetPortfolioAction());
    } catch (e) {
        yield call(failurePut, e, userPromocodeRemoveFailure);
    }
}

export function* updateAbTestIsUsedSaga({ payload }) {
    try {
        yield call(postRequest, '/ab-test/use', payload);
        yield put(updateAbTestIsUsedSuccess(payload));
    } catch (e) {
        yield call(failurePut, e, updateAbTestIsUsedFailure);
    }
}

export function* loadAccountTradeInfoSaga({ payload }) {
    try {
        const data = yield call(getRequest, `/account/${encodeURIComponent(payload)}/trade-info`);
        yield put(loadAccountTradeInfoSuccess({
            accountCode: data.accountCode,
            data,
        }))
    } catch (e) {
        yield call(failurePut, e, loadAccountTradeInfoFailure);
    }
}

export function* setRecentDoneSaga({ payload }) {
    try {
        yield call(getRequest, `/user/recent/${encodeURIComponent(payload)}/done`);
    } catch (e) {
    }
}

export function setUserSelectedAccountCodeSaga({ payload }) {
    localStorage.setItem('selectedAccount', payload);
}

export function* appSagas() {
    yield takeEvery(APP_INIT_START, appInitStartSaga);
    yield takeEvery(APP_LOG, appLogSaga);
    yield takeEvery(LOG_ACTION, logActionSaga);
    yield takeEvery(LOG_APPSFLYER_ACTION, logAppsflyerSaga);
    yield takeEvery('@@router/LOCATION_CHANGE', locationChangeSaga);
    yield takeEvery(USER_UPDATE_START, userUpdateSaga);
    yield takeEvery(USER_UPDATE_PASSWORD_START, userUpdatePasswordSaga);
    yield takeEvery(OPEN_MODAL, openModalSaga);
    yield takeEvery(CLOSE_MODAL, closeModalSaga);
    yield takeEvery(COMPLETE_ONBOARDING_START, completeOnboardingSaga);
    yield takeEvery(USER_PROMOCODE_APPLY_START, userPromocodeApplySaga);
    yield takeEvery(USER_PROMOCODE_REMOVE_START, userPromocodeRemoveSaga);
    yield takeEvery(UPDATE_AB_TEST_IS_USED_START, updateAbTestIsUsedSaga);
    yield takeEvery(LOAD_ACCOUNT_TRADE_INFO_START, loadAccountTradeInfoSaga);
    yield takeEvery(SET_RECENT_DONE, setRecentDoneSaga);
    yield takeEvery(SET_USER_SELECTED_ACCOUNT_CODE, setUserSelectedAccountCodeSaga);
}
